import { render } from "./Order_list.vue?vue&type=template&id=a1d50702"
import script from "./Order_list.vue?vue&type=script&lang=js"
export * from "./Order_list.vue?vue&type=script&lang=js"

import "./Order_list.vue?vue&type=style&index=0&id=a1d50702&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__